// extracted by mini-css-extract-plugin
export default {"root":"cOY3i__root Z3kBD__controlRoot","button":"Yn7kG__button YB6BY__iconButton","play":"FHUct__play","pause":"hOVLv__pause"};